import { memo } from 'react';

import { useAgentRunTree } from '@/hooks';

import { DetailsEmailPanel } from './DetailsEmailPanel.tsx';
import { useOpenPanel } from './useOpenPanel.ts';

export type DetailsEmailPanelWrapperProps = {
  agentId?: string;
  runId?: string;
};

const IDetailsEmailPanelWrapper = ({ agentId, runId }: DetailsEmailPanelWrapperProps) => {
  const { emailDocument } = useAgentRunTree({ agentId, runId });
  const { emailPanelOpen } = useOpenPanel();

  if (!emailPanelOpen || !emailDocument) return null;

  return <DetailsEmailPanel documentId={emailDocument.documentId} />;
};

export const DetailsEmailPanelWrapper = memo(IDetailsEmailPanelWrapper) as typeof IDetailsEmailPanelWrapper;
